import { rem as polishedRem } from 'polished';

type Pixel = number | string;
type Rem = string;

export function rem(value: Pixel): Rem {
  return polishedRem(value);
}

export function toRemString(values: number[]) {
  return values.map((value) => rem(value)).join(' ');
}
